import * as moment from 'moment';
import { Strategy } from 'utility-ts-strategy';
import { APCourse } from '../builders/ap_course_builder';

export interface IAPCourseRequisiteReminder {
  title: string;
  reminder_template: (course: APCourse) => string;
}

export type ap_course_requisite_type = 'prereq_outoforder' | 'prereq_miss' | 'coreq_outoforder' | 'coreq_miss';

export const APCourseRequisiteReminderStrategy = new Strategy<IAPCourseRequisiteReminder>({
  prereq_outoforder: {
    title: 'prereq_outoforder',
    reminder_template: (course: APCourse) =>
      `A prerequisite to <strong class="text-bold">${course.cd} ${course.title}</strong> is currently planned in a future term and needs to be completed before this course.`
  },
  prereq_miss: {
    title: 'prereq_miss',
    reminder_template: (course: APCourse) =>
      `<strong class="text-bold">${course.cd} ${course.title}</strong> has a prerequisite course that needs to be planned before this course.`
  },
  coreq_outoforder: {
    title: 'coreq_outoforder',
    reminder_template: (course: APCourse) =>
      `A co-requisite to <strong class="text-bold">${course.cd} ${course.title}</strong> is currently planned in a future term and needs to be completed at the same time as this course.`
  },
  coreq_miss: {
    title: 'coreq_miss',
    reminder_template: (course: APCourse) =>
      `<strong class="text-bold">${course.cd} ${course.title}</strong> has a co-requisite course that must be taken at the same time.`
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/ap_course_requisite_reminder_strategy.ts